export default import.meta.ROLLDOWN_FILE_URL_ZEYRu3a1CbVDbnF3PvrLmw